import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.simbatravel.co.uk";
const DEFAULT_OG_IMAGE = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Air_Zimbabwe_Boeing_767-200ER_Pichugin-1.jpg/1280px-Air_Zimbabwe_Boeing_767-200ER_Pichugin-1.jpg";

/**
 * Per-page SEO component. Renders a unique <title>, <meta name="description">,
 * canonical link and OpenGraph/Twitter tags for the current route.
 */
export default function Seo({ title, description, image, type = "website", noIndex = false }) {
  const location = useLocation();
  const canonical = `${SITE_URL}${location.pathname}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* OpenGraph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Simba Travel" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
